export default class NoteTemplatesWebService {
    constructor($sbRequest, API_VERSION) {
        "ngInject";
        this.$sbRequest = $sbRequest;
        this.API_VERSION = API_VERSION;
    }

    /**
     * This endpoint returns a list representation of the node templates.
     *
     * @param projectId {string}    UUID
     */
    getCollection(projectId) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/note-templates/`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "GET",
        });
    }

    /**
     * This endpoint returns the note template by id.
     *
     * @param projectId {string}    UUID
     * @param noteTemplateKey {integer}    The unique identifier of the noteTemplateK you are requesting a resource for.
     */
    get(projectId, noteTemplateKey) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/note-templates/${noteTemplateKey}`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "GET",
        });
    }

    /**
     * This endpoint creates a new note template in the project.
     *
     * @param projectId {string}    UUID
     *
     * @param body {Object}    Request body
     * @param body.code {string}    A user defined code for the note template.
     * @param body.text {string}    A text describing the reoccurring issue/note in detail.
     * @param body.type {string}    The type of note which should be created from the note template.
     */
    create(projectId, { code, text, type }) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/note-templates`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "POST",
            body: { code, text, type },
        });
    }

    /**
     * This endpoint allows to update some properties.
     *
     * @param projectId {string}    UUID
     * @param noteTemplateKey {integer}    The unique identifier of the noteTemplateK you are requesting a resource for.
     *
     * @param body {Object}    Request body
     * @param body.code {string}    A user defined code for the note template.
     * @param body.text {string}    A text describing the reoccurring issue/note in detail.
     * @param body.type {string}    The type of note which should be created from the note template.
     */
    update(projectId, noteTemplateKey, { code, text, type }) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/note-templates/${noteTemplateKey}`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "PUT",
            body: { code, text, type },
        });
    }

    /**
     * This endpoint allows to remove a note template.
     *
     * @param projectId {string}    UUID
     * @param noteTemplateKey {integer}    The unique identifier of the noteTemplateK you are requesting a resource for.
     */
    delete(projectId, noteTemplateKey) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/note-templates/${noteTemplateKey}`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "DELETE",
        });
    }
}
